import { component } from 'picoapp';
import app from '~/app';
import { buildArticleItem } from '~/js/utils/article-item';
import {
  getParam,
  loadMore,
  handlePagination,
} from '~/js/lib/infinite-pagination-helpers';

const blog = component((node, ctx) => {
  const { blogKey, articlesCount } = node.dataset;
  const output = node.querySelector('[data-article-output]');
  const paginationEl = node.querySelector('[data-pagination]');
  const loadMoreBtn = paginationEl.querySelector('[data-load-more]');
  const initPage = Number(getParam('p') ?? 1);
  let firstLoad = true;
  let loaded = 0;
  const loadedPages = [];

  ctx.hydrate({ blogPaginationLoaded: loaded });

  const updateOutput = (articles) => {
    if (articles.length) {
      output.classList.remove('hidden');

      articles.forEach((article) => {
        output.innerHTML += buildArticleItem(article, blogKey);
      });
    } else {
      output.classList.add('hidden');
      output.innerHTML = '';
    }
  };

  const getArticles = async () => {
    const currPage = Number(getParam('p') ?? initPage);
    const arbitaryData = {
      hits: Number(articlesCount),
    };

    const fetches = [];

    for (let p = 1; p <= currPage; p += 1) {
      if (!loadedPages.includes(p)) {
        fetches.push(fetch(`/blogs/${blogKey}?view=data&page=${p}`).then((r) => r.json()));
        loadedPages.push(p);
      }
    }

    await Promise.all(fetches)
      .then((data) => {
        const articles = data.flat();
        loaded += articles.length;
        ctx.hydrate({ blogPaginationLoaded: loaded });

        if (firstLoad) {
          const placeholders = [...output.querySelectorAll('[data-placeholder]')];
          if (placeholders.length) placeholders.forEach((x) => x.remove());
          firstLoad = false;
        }

        updateOutput(articles);
        handlePagination(arbitaryData, paginationEl, 'blog');
      });
  };

  getArticles();

  loadMoreBtn.addEventListener('click', () => {
    loadMore(() => {
      getArticles();
    });
  });
});

app.add({ blog });
app.mount();
